
var $basedriverNewsletterForm;
var $body;
var $header;
var $search;
var $searchOpen;
var $searchClose;
var $submenuOpen;
var $submenuClose;
var $submenu;
var $toggleFAQ;
var $toggleMenu;
var $menu;
var $loginMenu;
var $overlay;                    


$(document).ready(function($) {

    console.log('%cLinku Novio',"font-size: 2em; font-family: sans-serif; color: white; background-color:#18aaff; padding:4px 8px; border-radius: 4px");

    if (window.BdUserContent && typeof window.BdUserContent.initBdUserContent === 'function') {
        window.BdUserContent.initBdUserContent().catch(function () {});
    }

    $basedriverNewsletterForm   = $('.js-basedriver-newsletter-form');
    $body                       = $('body');
    $header                     = $('.js-header');
    $search                     = $('.js-search');
    $searchOpen                 = $('.js-search-open');
    $searchClose                = $('.js-search-close');
    $submenuOpen                 = $('.js-submenu-open');
    $submenuClose               = $('.js-submenu-close');
    $submenu                    = $('.js-submenu');
    $toggleFAQ                  = $('.js-toggle-faq');
    $toggleMenu                 = $('.js-toggle-menu');
    $menu                       = $('.js-menu');
    $loginMenu                  = $('.js-is-login-menu');
    $overlay                    = $('.js-overlay');

    $(window).on('scroll', function () {
        var scrollingHeaderClass = 's-header--shadow';

        if ($(this).scrollTop() >= 75 && !$header.hasClass(scrollingHeaderClass)) {
            $header.addClass(scrollingHeaderClass);
        } else if($(this).scrollTop() < 75 && $header.hasClass(scrollingHeaderClass)) {
            $header.removeClass(scrollingHeaderClass);
        }
    });

    $toggleMenu.on('click', function (e) {
        e.preventDefault(); // Prevents scrolling to top

        if ($(this).hasClass('is-open')) {
            $(this).removeClass('is-open');
            $menu.removeClass('is-open');
            $header.removeClass('s-header--mob-menu-is-open');
          } else {
            $(this).addClass('is-open');
            $menu.addClass('is-open');
            $loginMenu.removeClass('is-submenu-open');
            $overlay.removeClass('is-active');
            $header.addClass('s-header--mob-menu-is-open');
        }
    });

    $overlay.on('click', function (e) {
      $overlay.removeClass('is-active');
      $loginMenu.removeClass('is-submenu-open');
      $loginMenu.removeClass('is-open');

    });
    

    $submenuOpen.on('click', function (e) {
      if ($(this).parents('.js-is-login-menu').length === 0) {
        e.preventDefault(); // Prevents scrolling to top
      }
      
      if (!isMobile()) {
        if ($(this).parents('.js-is-login-menu').length === 0) {
          $(this).parents('.js-has-submenu').toggleClass('is-submenu-open');
          $overlay.addClass('is-active');
        }
      } else {
        if ($(this).parents('.js-is-login-menu').length > 0) {
          if( $(this).parents('.js-is-login-menu').hasClass('is-logged-in') ) {
            $(this).toggleClass('is-submenu-open');
            $overlay.toggleClass('is-active');
          }
        }
        $(this).parents('.js-has-submenu').toggleClass('is-submenu-open');
        
      }
    });

    $submenuClose.on('click', function (e) {
      e.preventDefault(); // Prevents scrolling to top
      $(this).removeClass('is-submenu-open');
      $(this).parents('.js-has-submenu').removeClass('is-submenu-open');
    });

    $searchOpen.on('click', function (e) {
        e.preventDefault();
        $header.addClass('has-open-search');
        $('body').addClass('has-open-search');
    });
    $searchClose.on('click', function (e) {
        e.preventDefault();
        $header.removeClass('has-open-search');
        $('body').removeClass('has-open-search');
    }
    );

    var emailPlaceholder = $('.form-email-label').html();
    $basedriverNewsletterForm.find('.wpbd-email').attr('placeholder', emailPlaceholder);

    $toggleFAQ.on('click', function (e) {
        e.stopPropagation();
        var activeClassName = 'is-open';

        if ($(this).hasClass(activeClassName)) {
            $(this).removeClass(activeClassName);
            $(this).next().slideUp();
        } else {
            $toggleFAQ.removeClass(activeClassName);
            $toggleFAQ.next().slideUp();

            $(this).addClass(activeClassName);
            $(this).next().slideDown();
        }
    });
});

function isMobile() {
    return window.matchMedia("only screen and (max-width:" + 992 + "px)").matches;
}
